import types from "../types/helpCenterActionTypes"

export const setTrainingGuidesData = (payload) => {
  return { type: types.SET_TRAINING_GUIDES_DATA, payload }
}
